const unitId = localStorage.getItem('global-selected-unit-id');

export const globalUnitId = {
    namespaced: true,
    state: unitId ?? null,
    actions: {
        setUnitId({ commit }, unitId) {
            commit('setUnitId', unitId);
        }
    },
    mutations: {
        setUnitId(state, unitId) {
            localStorage.setItem('global-selected-unit-id', unitId);
            state.globalUnitId = unitId;
        },
    }
};